import React from "react";

const SHAPE_OPTIONS = [
    { value: "rounded", label: "Rounded", radius: "0.5rem", preview: "rounded-md" },
    { value: "pill", label: "Pill", radius: "9999px", preview: "rounded-full" },
    { value: "square", label: "Square", radius: "0px", preview: "rounded-none" },
];

const RADIUS_PRESETS = [
    { value: "0px", label: "None" },
    { value: "0.25rem", label: "Small" },
    { value: "0.375rem", label: "Medium" },
    { value: "0.5rem", label: "Default" },
    { value: "0.75rem", label: "Large" },
    { value: "1rem", label: "Extra Large" },
];

export default function DesignSystemComponents({ components, onChange }) {
    const handleChange = (key, value) => {
        onChange({ ...components, [key]: value });
    };

    const currentShape = components?.buttonShape || "rounded";

    return (
        <div className="space-y-5">
            <h3 className="text-sm font-semibold">Component Styles</h3>
            <div className="space-y-4">
                <div>
                    <label className="text-sm font-medium">Button Shape</label>
                    <div className="flex gap-3 mt-2">
                        {SHAPE_OPTIONS.map((opt) => (
                            <button
                                key={opt.value}
                                type="button"
                                onClick={() => handleChange("buttonShape", opt.value)}
                                className={`px-4 py-2 text-sm border transition-colors ${
                                    opt.preview
                                } ${
                                    currentShape === opt.value
                                        ? "border-primary bg-primary text-primary-foreground"
                                        : "border-input bg-background hover:bg-accent"
                                }`}
                                style={{ borderRadius: opt.radius }}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </div>
                </div>
                <div>
                    <label className="text-sm font-medium">Border Radius</label>
                    <select
                        value={components?.borderRadius || "0.5rem"}
                        onChange={(e) => handleChange("borderRadius", e.target.value)}
                        className="block w-full mt-1 px-3 py-2 border border-input rounded-md bg-background text-sm"
                    >
                        {RADIUS_PRESETS.map((r) => (
                            <option key={r.value} value={r.value}>{r.label} ({r.value})</option>
                        ))}
                    </select>
                    <div className="mt-2 flex gap-3">
                        <div
                            className="w-16 h-16 border-2 border-primary bg-muted"
                            style={{ borderRadius: components?.borderRadius || "0.5rem" }}
                        />
                        <div
                            className="w-32 h-10 border-2 border-primary bg-muted"
                            style={{ borderRadius: components?.borderRadius || "0.5rem" }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
